import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { createSearchParams, useNavigate, useParams } from "react-router-dom";
import { Wizard, useWizard } from 'react-use-wizard';
import StepClinicInformation, { getStartDate } from './StepClinicInformation';
import StepServicesRequested from './StepServicesRequested';
import WizardLayout from './WizardLayout';
import { setDate, setMonth, subYears } from 'date-fns'
import { useIntakeFormService } from '../services/IntakeFormService';
import StepAnimated from './StepAnimated';
import { toast } from 'react-toastify';

const Header = ({ stepNames }) => {

    const {
        activeStep,
        stepCount,
        goToStep,
    } = useWizard();

    return (
        <ul className='stepper'>
            {
                new Array(stepCount).fill(0).map((_, i) => {
                    let className = (activeStep > (i)) ? 'pastStep' : (activeStep === i) ? 'currentStep' : '';
                    return <li key={i} onClick={() => {
                        goToStep && goToStep(i);
                    }} className={className}><span>{i + 1}</span><div>{stepNames && stepNames[i]}</div></li>
                })
            }
        </ul>
        // <div className="header">
        //   <hr />
        //   {
        //     new Array(stepCount).fill(0).map((_, i) => {
        //       let className = (activeStep > (i)) ? 'pastStep' : (activeStep === i) ? 'currentStep' : '';
        //       return <span key={i} onClick={()=>{
        //         goToStep && goToStep(i);
        //       }} className={className}>{i + 1}</span>
        //     })
        //   }
        // </div>
    )
}

export const Intake = () => {

    const navigate = useNavigate();
    const { clinicUniqueId } = useParams()
    const intakeService = useIntakeFormService()
    const submittingToastId = React.useRef(null);

    useEffect(() => {
        Intake.displayName = Intake.name;
    }, [])

    const [activeStep, setActiveStep] = useState(0)
    const [showServicesRequested, setShowServicesRequested] = useState(true)
    const stateReducer = useCallback((state, action) => {
        //console.log('state', state)
        //console.log('action.name', action.name, 'action.value', action.value)

        switch (action.type) {
            case 'SET': {
                // eslint-disable-next-line no-undef
                if (action.name !== 'errors' && action.name !== 'data' && isFunction(context.StepState[activeStep].setValue)) {
                    context.StepState[activeStep].setValue(action.name, action.value, { shouldValidate: context.StepState[activeStep].isSubmitted })
                }

                context.StepState[activeStep][action.name] = action.value

                return {
                    ...context.StepState[activeStep],
                    [action.name]: action.value
                }
                //return context.StepState[activeStep]
                // return {
                //   ...state,
                //   [action.name]: action.value
                // }
            }
            // case 'CONTEXT_SET': {
            //   console.log('CONTEXT_SET called')
            //   console.log('Setting: ', action.name, 'to', action.value)
            //   context[action.name] = action.value

            //   return state
            // }
            // case 'CHANGE_STEP': {
            //   context.activeStep = action.value

            //   return context.StepState[action.value]

            //   // return {
            //   //   ...state,
            //   //   //[action.name]: action.value
            //   // }
            // }
            // case 'SET_INSURANCE_CARDS': {
            //   const files = state.insuranceCards
            //   files.forEach((file, i) => {
            //     //console.log('Type', file)
            //     //console.log('getMetadata', file.getMetadata())
            //     //console.log('file.file', file.file)
            //     //console.log('file.origin', file.origin)
            //     //console.log('file.source', file.source)
            //     //console.log('file.id', file.id)
            //     //console.log('file.serverId', file.serverId)
            //     // action.value.forEach((newfile, i) => {

            //     //   if (newfile.status === 9) {
            //     //     newfile.setMetadata('customServerId', file.serverId, false)
            //     //   }
            //     //   console.log(newfile.getMetadata())
            //     //   //if (newfile.id !== file.id) {
            //     //     //console.log('setting the serverId to be equal!!!!')
            //     //     //newfile.setMetadata('customServerId', file.serverId, false)
            //     //     file.options = {
            //     //       metaData: {
            //     //         customServerId: newfile.serverId
            //     //       },
            //     //       type: 'limbo', // local to indicate an already uploaded file, so it hits the load endpoint
            //     //       // fileMetadataObject: {
            //     //       //    customServerId: file.serverId,
            //     //       // }
            //     //     }
            //     //     action.value[i] = file
            //     //   //}
            //     // })
            //     //action.value[i] = file
            //     file.options = {
            //       type: 'limbo'
            //     }
            //   })



            //   // eslint-disable-next-line no-undef
            //   if (isFunction(state.setValue)) {
            //     state.setValue(action.name, action.value, { shouldValidate: state.isSubmitted })
            //   }

            //   context.StepState[context.activeStep][action.name] = action.value

            //   return {
            //     ...state,
            //     [action.name]: action.value
            //   }
            // }
            default:
                return state
        }
    }, [activeStep])
    
    const submitResults = useCallback(async (isLastStep, lastStepData) => {
        console.log('====================================')
        console.log('submitResults called')

        let allStepsValid = true;
        let firstInvalidStep = -1;
        let warning = '';
        context.StepState.forEach((step, i) => {
            if (step.errors.length !== 0) {
                console.log('THERE ARE ERRORS IN STEP ' + (i + 1))
                if (allStepsValid) {
                    firstInvalidStep = i;
                    warning = 'errors';
                }
                allStepsValid = false;
            } else if ((!step.isSubmitted && i < context.StepState.length - 1)) {
                console.log('STEP IS NOT SUBMITTED ' + (i + 1))
                if (allStepsValid) {
                    warning = 'unsubmitted';
                    firstInvalidStep = i;
                }
                allStepsValid = false;
            } else {
                console.log('STEP OK ' + (i + 1))
                console.log('STEP DATA', step.data)
            }
        });

        console.log('====================================')

        if (allStepsValid) {
            submittingToastId.current = toast.success('Submitting', {
                position: "bottom-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: false,
            });

            // Validate required fields before creating payload
            const formData = context.StepState[0].data;
            
            // Check for required fields
            if (!formData.locationUniqueId) {
                toast.error('Clinic information is missing', { 
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                toast.dismiss(submittingToastId.current);
                return 0;
            }

            if (!formData.provider?.value) {
                toast.error('Provider selection is required', { 
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                toast.dismiss(submittingToastId.current);
                return 0;
            }

            if (!formData.patientFirstName || !formData.patientLastName) {
                toast.error('Patient name is required', { 
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                toast.dismiss(submittingToastId.current);
                return 0;
            }

            if (!formData.startDatestartDate || !formData.dob) {
                toast.error('Date fields are required', { 
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                toast.dismiss(submittingToastId.current);
                return 0;
            }

            if (!formData.benefitNetwork?.value) {
                toast.error('Benefit network selection is required', { 
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                toast.dismiss(submittingToastId.current);
                return 0;
            }
            if (formData.isPIWC && !formData.dateOfAccident) {
                toast.error('Date of accident is required', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                toast.dismiss(submittingToastId.current);
                return 0;
            }
            // Validate conditional insurance fields
            const validateInsuranceFields = (insuranceCompany, insuranceId, fieldPrefix = '') => {
                const hasInsuranceCompany = insuranceCompany?.value && !isNaN(insuranceCompany.value) && insuranceCompany.value > 0;
                if (hasInsuranceCompany) {
                    if (!insuranceCompany?.label || insuranceCompany.label.trim() === '') {
                        toast.error(`${fieldPrefix}Insurance Company Name is required when an insurance company is selected`, { 
                            position: "bottom-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        return false;
                    }
                    
                    if (!insuranceId || insuranceId.trim() === '') {
                        toast.error(`${fieldPrefix}Insurance ID is required when an insurance company is selected`, { 
                            position: "bottom-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        return false;
                    }
                }
                return true;
            };

            // Validate primary insurance
            if (!validateInsuranceFields(formData.insuranceCompany, formData.insuranceId)) {
                toast.dismiss(submittingToastId.current);
                return 0;
            }

            // Validate secondary insurance if enabled
            if (formData.hasSecondaryInsurance) {
                if (!validateInsuranceFields(formData.secondaryInsuranceCompany, formData.secondaryInsuranceId, 'Secondary ')) {
                    toast.dismiss(submittingToastId.current);
                    return 0;
                }
            }

            console.log('🟢 DEBUG: formData before payload creation:', formData);

            // Create payload with correct field names matching IntakeData model
            let payload = {
                // Required fields that match IntakeData model exactly
                Clinic: formData.locationUniqueId,
                RequestedBackDate: formData.startDatestartDate,  // CRITICAL: This was missing
                DateOfBirth: formData.dob,  // CRITICAL: This was missing
                Provider: formData.provider.value,
                PatientFirstName: formData.patientFirstName,
                PatientLastName: formData.patientLastName,
                PatientId: formData.patientId || "",
                
                // Fix insurance company field - handle null/undefined properly
                InsuranceCompany: formData.insuranceCompany?.value && !isNaN(formData.insuranceCompany.value) && formData.insuranceCompany.value > 0 
                    ? formData.insuranceCompany.value 
                    : null,
                InsuranceCompanyName: formData.insuranceCompany?.label || "",
                InsuranceId: formData.insuranceId || "",
                
                //HasSecondaryInsurance: formData.hasSecondaryInsurance || false,
                
                //// Fix secondary insurance fields - handle conditional validation properly
                //SecondaryInsuranceCompany: formData.hasSecondaryInsurance && formData.secondaryInsuranceCompany?.value && !isNaN(formData.secondaryInsuranceCompany.value) && formData.secondaryInsuranceCompany.value > 0
                //    ? formData.secondaryInsuranceCompany.value
                //    : null,
                //SecondaryInsuranceCompanyName: formData.hasSecondaryInsurance ? (formData.secondaryInsuranceCompany?.label || "") : "",
                //SecondaryInsuranceId: formData.hasSecondaryInsurance ? (formData.secondaryInsuranceId || "") : "",
                
                BenefitNetwork: formData.benefitNetwork.value,
                UrgencyLevel: formData.urgencyLevelChecked.findIndex((option) => option) + 1,
                AdditionalComments: formData.additionalComments || "",  // CRITICAL: This was missing
                InsuranceCards: formData.filepond || []
            };

            // Add dynamically evaluated fields
            let otherFieldsModel = {};
            context.StepState[1].evFields.forEach(group => {
                group.fields.forEach(evField => {
                    const fieldName = evField.field;
                    const fieldValue = lastStepData[fieldName];

                    if (fieldName.startsWith("Other_")) {
                        delete otherFieldsModel[fieldName];
                        otherFieldsModel[fieldName.substring(6)] = fieldValue;
                    }
                    else {
                        payload[fieldName] = fieldValue;
                    }
                });
            });

            payload.OtherFields = otherFieldsModel;


            // Include PI/WC data if enabled
            if (formData.isPIWC) {
                payload.IsPIWC = true;
                if (formData.dateOfAccident) {
                    const d = new Date(formData.dateOfAccident);
                    const year = d.getFullYear();
                    const month = String(d.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
                    const day = String(d.getDate()).padStart(2, '0');
                    payload.PI_DateOfAccident = `${year}-${month}-${day}`; // e.g. "2025-08-02"
                } 
                payload.IDCaseType = parseInt(formData.caseType) || 0;
                payload.PayerClaimNo = formData.insuranceClaimNumber || "";
                payload.PayerName = formData.insuranceCompany?.label || "";
                payload.PayerPhoneNo = formData.insuranceCompanyPhone || "";
                payload.PayerFaxNo = formData.insuranceCompanyFax || "";
                payload.PayerEmail = formData.insuranceCompanyEmail || "";
                payload.AdjusterPhoneNo = formData.adjusterPhone || "";
                payload.AdjusterFaxNo = formData.adjusterFax || "";
                payload.AdjusterEmail = formData.adjusterEmail || "";
                payload.PIClaimNumber = formData.piwcClaimNumber || "";
                payload.DoesHaveAttorney = formData.hasAttorney || false;
                payload.AttorneyName = formData.attorneyName || "";
                payload.AttorneyPhoneNo = formData.attorneyPhone || "";
                payload.AttorneyFaxNo = formData.attorneyFax || "";
                payload.AttorneyEmail = formData.attorneyEmail || "";
                payload.IsSentLopAttorney = formData.wasLopSent || false;
                payload.PI_AdjusterName = formData.adjusterName || "";
            } else {
                payload.IsPIWC = false;
            }

            console.log('submit payload', payload);

            const saveResults = await intakeService.SaveIntakeData(payload);
            toast.dismiss(submittingToastId.current);

            if (saveResults.isSuccess) {
                navigate({
                    pathname: `/IntakeComplete/${clinicUniqueId}`,
                    search: createSearchParams({
                        internalRef: saveResults.internalRef
                    }).toString()
                });
            } else {
                toast.error(saveResults.message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                return 0;
            }

            return -1;
        } else {
            toast.error(warning === 'unsubmitted' ? 'Please complete the form.' : 'Please correct all errors.', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });

            return firstInvalidStep;
        }
    }, []);


    const ClinicInformationState = useMemo(() => {
        return {
            isSubmitted: false,
            errors: [],
            data: [],
            submitResults,
            setValue: () => { },
            locationUniqueId: clinicUniqueId,
            //locationUniqueId: 'CC504D4A-7D9B-45CD-9ECE-9BA86924DD6C', //localhost
            //locationUniqueId: '02B46247-13A6-453C-80B4-4544AAC0D40C', //test
            //locationUniqueId: '0FFF31A4-8E83-439D-B01D-450D95985114', //prod
            minStartDate: getStartDate(new Date(), 'init minStartDate'),
            excludeTimes: [],
            startDatestartDate: getStartDate(new Date(), 'init startDate'),
            dob: setMonth(setDate(subYears(new Date(), 30), 1), 0),
            additionalComments: '',
            clinic: '',
            provider: '',
            patientFirstName: '',
            patientLastName: '',
            patientId: '',
            insuranceCompany: '',
            insuranceId: '',
            insuranceCards: [],
            hasSecondaryInsurance: false,
            secondaryInsuranceCompany: '',
            secondaryInsuranceId: '',
            benefitNetwork: 2,
            urgencyLevelChecked: [true, false, false],
            isDoctorTitle: false,
            isDME: false,
            CMT_98943_ExtremityAdjustmentEnabled: false,
            CMT_9894s_SpinalAdjustmentEnabled: false,
            EM_9920s_InitialEvaluationEnabled: false,
            EM_96156_BehavioralHealthAssessmentEnabled: false,
            EM_992ss_EstablishedPatientEvaluationEnabled: false,
            IMG_72sss_XRayEnabled: false,
            PMR_97012_TractionEnabled: false,
            PMR_97530_TherapeuticActivitiesEnabled: false,
            PMR_97112_NeuromuscularEducationEnabled: false,
            PMR_97110_TherapeuticExerciseEnabled: false,
            PMR_97014_G0283_EStimEnabled: false,
            PMR_2056s_DryNeedlingEnabled: false,
            PMR_97150_GroupTherapyEnabled: false,
            PMR_97140_ManualTherapyEnabled: false,
            MT_97124_MassagePerformedByDCEnabled: false,
            MT_97124_MassagePerformedByMTEnabled: false,
            ACP_9781s_AcupunctureEnabled: false,
            DME_E0730_TENSEnabled: false,
            DME_L3020_Foot_InsertRemovableEnabled: false,
            DME_L0456_TLSOCustomizedEnabled: false,
            DME_L1832_KneeBraceEnabled: false,
            DME_L0648_OrthosisOffTheShelfEnabled: false,
            DME_L0180_CervicalCollarEnabled: false,
            DME_L1005_ScoliBraceEnabled: false,
            DME_L3000_CustomMoldedShoeOrthoticEnabled: false,
            DME_L0457_TLSOBraceEnabled: false,
            DME_L0650_LumbarSacralOrthosisEnabled: false,
            MED_20610_IntraArtInjWithoutUSGEnabled: false,
            MED_20611_ArthroMajorJointOrBursaEnabled: false,
            MED_20611_IntraArtInjWithUSGEnabled: false,
            MED_20553_TrigPointInj_3MusclesEnabled: false,
            MED_64515_NerveBlockStellateGanglionEnabled: false,
            MED_J0585_OnabotulinumtoxinaEnabled: false,
            MED_J7318_DurolaneEnabled: false,
            MED_J7320_GenviscEnabled: false,
            MED_J7321_HyalganSupartzVisco3DoseEnabled: false,
            MED_J7323_EuflexxaEnabled: false,
            MED_J7325_SynviscOrSynviscOneEnabled: false,
            MED_J7328_Gelsyn3Enabled: false,
            MED_J7329_TriviscEnabled: false,

            holiday: '',

            //PI/WC
            isPIWC: false,
            dateOfAccident: null,
            caseType: '',
            insuranceClaimNumber: '',
            insuranceCompanyName: '',
            insuranceCompanyPhone: '',
            insuranceCompanyFax: '',
            insuranceCompanyEmail: '',
            adjusterName:'',
            adjusterPhone: '',
            adjusterFax: '',
            adjusterEmail: '',
            piwcClaimNumber: '',
            hasAttorney: false,
            attorneyName: '',
            attorneyPhone: '',
            attorneyFax: '',
            attorneyEmail: '',
            wasLopSent: false,
        }
    }, [submitResults])
 
    const ServicesRequestedState = useMemo(() => {

        const evFields = [
            {
                group: 'CMT',
                label: 'Chiropractic Coverage',
                fields: [
                    { field: 'CMT_98943_ExtremityAdjustmentEnabled', label: '98943 - Extremity Adjustment' },
                    { field: 'CMT_9894s_SpinalAdjustmentEnabled', label: '9894* - Spinal Adjustment' }
                ]
            },
            {
                group: 'EM',
                label: 'E/M Coverage',
                fields: [
                    { field: 'EM_9920s_InitialEvaluationEnabled', label: '9920* - Initial Evaluation' },
                    { field: 'EM_96156_BehavioralHealthAssessmentEnabled', label: '96156 - Behavioral Health Assessment' },
                    { field: 'EM_992ss_EstablishedPatientEvaluationEnabled', label: '992** - Established Patient Evaluation' }
                ]
            },
            {
                group: 'IMG',
                label: 'Imaging Coverage',
                fields: [
                    { field: 'IMG_72sss_XRayEnabled', label: '72*** - X-Ray' }
                ]
            },
            {
                group: 'PMR',
                label: 'Physical Therapy Coverage',
                fields: [
                    { field: 'PMR_97012_TractionEnabled', label: '97012 - Traction' },
                    { field: 'PMR_97530_TherapeuticActivitiesEnabled', label: '97530 - Therapeutic Activities' },
                    { field: 'PMR_97112_NeuromuscularEducationEnabled', label: '97112 - Neuromuscular Education' },
                    { field: 'PMR_97110_TherapeuticExerciseEnabled', label: '97110 - Therapeutic Exercise' },
                    { field: 'PMR_97014_G0283_EStimEnabled', label: '97014/G0283 - EStim' },
                    { field: 'PMR_2056s_DryNeedlingEnabled', label: '2056* - Dry Needling' },
                    { field: 'PMR_97150_GroupTherapyEnabled', label: '97150 - Group Therapy' },
                    { field: 'PMR_97140_ManualTherapyEnabled', label: '97140 - Manual Therapy' }
                ]
            },
            {
                group: 'MT',
                label: 'Massage Therapy Coverage',
                fields: [
                    { field: 'MT_97124_MassagePerformedByDCEnabled', label: '97124 - Massage Performed by DC' },
                    { field: 'MT_97124_MassagePerformedByMTEnabled', label: '97124 - Massage Performed by Massage Therapist' },
                ]
            },
            {
                group: 'ACP',
                label: 'Acupuncture Coverage',
                fields: [
                    { field: 'ACP_9781s_AcupunctureEnabled', label: '9781* - Acupuncture' }
                ]
            },
            {
                group: 'DME',
                label: 'Durable Medical Equipment Coverage',
                fields: [
                    { field: 'DME_E0730_TENSEnabled', label: 'E0730 - TENS' },
                    { field: 'DME_L3020_Foot_InsertRemovableEnabled', label: 'L3020 - Foot, Insert Removable' },
                    { field: 'DME_L0456_TLSOCustomizedEnabled', label: 'L0456 - TLSO Customized' },
                    { field: 'DME_L1832_KneeBraceEnabled', label: 'L1832 - Knee Brace' },
                    { field: 'DME_L0648_OrthosisOffTheShelfEnabled', label: 'L0648 - Orthosis Off The Shelf' },
                    { field: 'DME_L0180_CervicalCollarEnabled', label: 'L0180 - Cervical Collar' },
                    { field: 'DME_L1005_ScoliBraceEnabled', label: 'L1005 - Scoli Brace' },
                    { field: 'DME_L3000_CustomMoldedShoeOrthoticEnabled', label: 'L3000 - Custom Molded Shoe Orthotic' },
                    { field: 'DME_L0457_TLSOBraceEnabled', label: 'L0457 - TLSO Brace' },
                    { field: 'DME_L0650_LumbarSacralOrthosisEnabled', label: 'L0650 - Lumbar Sacral Orthosis' }
                ]
            },
            {
                group: 'MED',
                label: 'Medical Coverage',
                fields: [
                    { field: 'MED_20610_IntraArtInjWithoutUSGEnabled', label: '20610 - Intraarticular Injection w/out Ultrasound Guidance' },
                    { field: 'MED_20611_ArthroMajorJointOrBursaEnabled', label: '20611 - Arthrocentesis major joint or bursa' },
                    { field: 'MED_20611_IntraArtInjWithUSGEnabled', label: '20611 - Intraarticular Injection w Ultrasound Guidance' },
                    { field: 'MED_20553_TrigPointInj_3MusclesEnabled', label: '20553 - Trigger Point Injections, 3 muscles' },
                    { field: 'MED_64515_NerveBlockStellateGanglionEnabled', label: '64515 - Nerve block on the stellate ganglion' },
                    { field: 'MED_J0585_OnabotulinumtoxinaEnabled', label: 'J0585 - Onabotulinumtoxina' },
                    { field: 'MED_J7318_DurolaneEnabled', label: 'J7318 - Durolane' },
                    { field: 'MED_J7320_GenviscEnabled', label: 'J7320 - Genvisc' },
                    { field: 'MED_J7321_HyalganSupartzVisco3DoseEnabled', label: 'J7321 - Hyalgan supartz visco-3 dose' },
                    { field: 'MED_J7323_EuflexxaEnabled', label: 'J7323 - Euflexxa' },
                    { field: 'MED_J7325_SynviscOrSynviscOneEnabled', label: 'J7325 - Synvisc or synvisc-one' },
                    { field: 'MED_J7328_Gelsyn3Enabled', label: 'J7328 - Gelsyn-3' },
                    { field: 'MED_J7329_TriviscEnabled', label: 'J7329 - Trivisc' }
                ]
            },
        ]

        const basicTabFields = {
            isSubmitted: false,
            errors: [],
            data: [],
            submitResults,
            setValue: () => { },
            disableNavigationLastStep: false,
            disableNavigationLastStep2: false,
            isDME: false,
            CMT_98943_ExtremityAdjustmentEnabled: false,
            CMT_9894s_SpinalAdjustmentEnabled: false,
            EM_9920s_InitialEvaluationEnabled: false,
            EM_96156_BehavioralHealthAssessmentEnabled: false,
            EM_992ss_EstablishedPatientEvaluationEnabled: false,
            IMG_72sss_XRayEnabled: false,
            PMR_97012_TractionEnabled: false,
            PMR_97530_TherapeuticActivitiesEnabled: false,
            PMR_97112_NeuromuscularEducationEnabled: false,
            PMR_97110_TherapeuticExerciseEnabled: false,
            PMR_97014_G0283_EStimEnabled: false,
            PMR_2056s_DryNeedlingEnabled: false,
            PMR_97150_GroupTherapyEnabled: false,
            PMR_97140_ManualTherapyEnabled: false,
            MT_97124_MassagePerformedByDCEnabled: false,
            MT_97124_MassagePerformedByMTEnabled: false,
            ACP_9781s_AcupunctureEnabled: false,
            DME_E0730_TENSEnabled: false,
            DME_L3020_Foot_InsertRemovableEnabled: false,
            DME_L0456_TLSOCustomizedEnabled: false,
            DME_L1832_KneeBraceEnabled: false,
            DME_L0648_OrthosisOffTheShelfEnabled: false,
            DME_L0180_CervicalCollarEnabled: false,
            DME_L1005_ScoliBraceEnabled: false,
            DME_L3000_CustomMoldedShoeOrthoticEnabled: false,
            DME_L0457_TLSOBraceEnabled: false,
            DME_L0650_LumbarSacralOrthosisEnabled: false,
            MED_20610_IntraArtInjWithoutUSGEnabled: false,
            MED_20611_ArthroMajorJointOrBursaEnabled: false,
            MED_20611_IntraArtInjWithUSGEnabled: false,
            MED_20553_TrigPointInj_3MusclesEnabled: false,
            MED_64515_NerveBlockStellateGanglionEnabled: false,
            MED_J0585_OnabotulinumtoxinaEnabled: false,
            MED_J7318_DurolaneEnabled: false,
            MED_J7320_GenviscEnabled: false,
            MED_J7321_HyalganSupartzVisco3DoseEnabled: false,
            MED_J7323_EuflexxaEnabled: false,
            MED_J7325_SynviscOrSynviscOneEnabled: false,
            MED_J7328_Gelsyn3Enabled: false,
            MED_J7329_TriviscEnabled: false,
        }

        let extendedFields = { evFields: evFields }
        evFields.forEach(evGroup => {
            evGroup.fields.forEach(evField => {
                extendedFields[evField.field] = evField.defaultValue
            })
        })

        const merged = {
            ...basicTabFields,
            ...extendedFields
        }

        //console.log(merged)

        return merged;

    }, [submitResults])

    // const setDisableNavigationLastStep = (disabled) => {
    //   console.log('setDisableNavigationLastStep', disabled)
    //   context.disableNavigationLastStep = disabled
    // }

    //const previousStep = React.useRef(0);
    const bodyRef = React.useRef(React.createRef());

    const context = useMemo(() => {
        return {
            reducer: stateReducer,
            StepState: [ClinicInformationState, ServicesRequestedState],
            //activeStep: 0,
            //previousStep: 0,
            activeStep,
            setActiveStep,
            disableNavigation: false,
            //valueA: new Date(),
            //valueB: 'Yeah!'
        }
    }, [stateReducer, ClinicInformationState, ServicesRequestedState, activeStep, setActiveStep])

    // const setPreviousStep = React.useCallback((previousStep) => {
    //   console.log("setting previous step", previousStep)
    //   context.previousStep = previousStep
    // }, [context])

    return (
        <WizardLayout context={context}>
            <Wizard.Header>Insurance Verification Request</Wizard.Header>
            <Wizard.Body bodyRef={bodyRef}>
                <Wizard
                    header={
                        <Header
                            stepNames={[
                                'Clinic Information',
                                'Services Requested',
                                ...(showServicesRequested ? ['Services Requested'] : [])
                            ]}
                        />}
                >
                    <StepAnimated
                        // previousStep={context.previousStep}
                        // setPreviousStep={setPreviousStep}
                        bodyRef={bodyRef}
                    >
                        <StepClinicInformation stepName={"ClinicInformation"} onToggleFullEV={(checked) => setShowServicesRequested(!checked)} />
                    </StepAnimated>

                    {showServicesRequested && (
                        <StepAnimated bodyRef={bodyRef}>
                            <StepServicesRequested stepName={"ServicesRequested"} />
                        </StepAnimated>
                    )}
                </Wizard>
            </Wizard.Body>
        </WizardLayout>
    )
}
